//@ts-check
(function () {
  var sectionHeader = document.getElementById('section-header');
  var aboveMobile = window.matchMedia('(min-width: 768px)');
  window.addEventListener('scroll', function (ev) {
    var promoBanner = document.querySelector('.hero-tooltip');
    var promoHeight = (promoBanner ? promoBanner.offsetHeight : 0);
    var topHeight = 0;
    var replaceHeight = 0;

    if (aboveMobile.matches) {
      var headerMainNav = document.querySelector('.MainNav__bottomMenu');
      var headerHeight = sectionHeader.offsetHeight - headerMainNav.offsetHeight;
      replaceHeight = headerMainNav.offsetHeight;
      topHeight = promoHeight + headerHeight;
    } else {
      topHeight = promoHeight;
      replaceHeight = document.querySelector('.Header__top-row').offsetHeight;
    }

    if (window.scrollY >= topHeight) {
      sectionHeader.classList.add('Header--scrolling');
      sectionHeader.style.paddingTop = replaceHeight + 'px';
    } else {
      sectionHeader.classList.remove('Header--scrolling');
      sectionHeader.style.paddingTop = '0px';
    }

    /**
     * PDP Sticky CTA Header scrolling functionality
     */
    const activePdpStickyCtaClass = 'active';
    const headerSlideUpClass = 'Header--pdpHide'
    const pdpSimple = document.getElementById('shopify-section-product-template-simple')
    const pdpConfigurator = document.getElementById('shopify-section-product-template')
    var pdpEle;
    if (pdpSimple) {
      pdpEle = pdpSimple;
    }
    else {
      pdpEle = pdpConfigurator;
    }
    //const pdpEle = pdpSimple ?? pdpConfigurator;
    let pdpStickyCta = document.getElementById('pdp-sticky-cta');

    let pdpDisplayThreshold = 400

    if (pdpEle) {
      pdpDisplayThreshold = pdpEle.offsetTop + pdpEle.offsetHeight;
    }

    if (pdpStickyCta != null && window.pageYOffset >= pdpDisplayThreshold) {
      pdpStickyCta.style.top = '0';
      pdpStickyCta.classList.add(activePdpStickyCtaClass)
      sectionHeader.classList.add(headerSlideUpClass)
    } else if (pdpStickyCta != null && window.pageYOffset < pdpDisplayThreshold) {
      pdpStickyCta.style.top = sectionHeader.offsetHeight + 'px';
      pdpStickyCta.classList.remove(activePdpStickyCtaClass)
      sectionHeader.classList.remove(headerSlideUpClass)
    }
  });
})();



document.addEventListener('theme:loading:end', (event) => {
  const sortByPopover = document.querySelector('#collection-sort-popover');
  if (sortByPopover) {
    const selectedSortBy = sortByPopover.querySelector('.is-selected');

    if (selectedSortBy) {
      document.querySelector('.CollectionToolbar__Item--sort span').textContent = selectedSortBy.textContent.trim();
    }
  }

  const productListWrapper = document.querySelector('.ProductListWrapper');

  if (productListWrapper && productListWrapper.dataset.productCount) {
    const productCount = productListWrapper.dataset.productCount;
    const productCountElement = document.querySelector('.CollectionToolbar__ProductCount');
    const splitText = productCountElement.textContent.split(" ");
    splitText[0] = productCount;
    productCountElement.textContent = splitText.join(" ");
  }
});

window['Haworth'] = window['Haworth'] || {};
window['Haworth'].generateRange = function (start, stop, step) {
  var a = [start],
    b = start;
  while (b < stop) {
    a.push((b += step || 1));
  }
  return a;
};

window['Haworth'].getDiscountedPrice = function (baseIdentifier, sku, originalPrice) {
  if (window['Haworth'].pricingData == null) {
    return originalPrice;
  }
  var pricingData = /** @type {import("./haworth-theme").PricingData} */ (window['Haworth'].pricingData);
  if (Object.keys(pricingData.SkuDiscounts).some((key) => key == sku)) {
    return pricingData.SkuDiscounts[sku];
  }

  if (Object.keys(pricingData.BaseIdentifierDiscountPercentages).some((key) => key == baseIdentifier)) {
    return originalPrice - originalPrice * (pricingData.BaseIdentifierDiscountPercentages[baseIdentifier] / 100);
  }

  return originalPrice;
};

window['Haworth'].productData = {};

window['Haworth'].pricingData = null;


function recommendedAddToCart(e, id, whiteGloveEligible, isDrawer) {
  e.stopPropagation();
  var formData = {
    'items': [{
      'quantity': 1,
      'id': id,
      properties: {
        "whiteGloveEligible": whiteGloveEligible
      }
    }]
  };

  var buttonClicked = e.target;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(function (response) {
      buttonClicked.textContent = buttonClicked.getAttribute('data-added-text');

      if (isDrawer) {
        rerenderCartDrawer();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });

  e.preventDefault();
}

function rerenderCartDrawer() {
  return fetch(window.routes.cartUrl + '?view=drawer' + '&timestamp=' + Date.now(), {
    credentials: 'same-origin',
    method: 'GET'
  }).then(function (content) {
    content.text().then(function (html) {
      var tempElement = document.createElement('div');
      tempElement.innerHTML = html;

      var cartNodeParent = document.querySelector('.Drawer--cart');
      var cartNodeItemParent = document.querySelector('.Drawer__Items').parentNode;
      var cartNodeFooterParent = document.querySelector('.Drawer__Footer').parentNode;

      cartNodeItemParent.replaceChild(tempElement.querySelector('.Drawer__Items'), document.querySelector('.Drawer__Items'));
      cartNodeParent.replaceChild(tempElement.querySelector('.Drawer__Header--cart'), cartNodeParent.querySelector('.Drawer__Header--cart'));
      cartNodeFooterParent.replaceChild(tempElement.querySelector('.Drawer__Footer'), cartNodeParent.querySelector('.Drawer__Footer'));

      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  })
}

document.addEventListener('theme:loading:end', function (event) {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      var cartCount = document.querySelectorAll('.Header__CartDot');
      for (var i in cartCount) {
        cartCount[i].innerHTML = data.item_count;
      }
    });
});


/**
 * Gets a cloudflare url for the specified width
 *
 * @param {string} url
 * @param {string | number} width
 * @returns
 */
function getCloudflareImageUrl(url, width) {
  if (url == '' || url == null || width == undefined) {
    return url;
  }
  var urlParsed = new URL(url);
  urlParsed.pathname = `cdn-cgi/image/width=${width}` + urlParsed.pathname;
  return urlParsed.toString().replace('%7Bwidth%7D', '{width}');
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

//focuses first name on contact form when send a message is clicked
function focusFirstName() {
  var firstNameForm = document.getElementsByName('contact[first_name]');
  firstNameForm[0].focus();
}

var lastClicked = null;
function getID(clicked_id) {
  lastClicked = clicked_id;
}

document.addEventListener('theme:loading:end', function () {
  if (lastClicked != null) {
    var increases = document.querySelectorAll('#' + lastClicked);
    for (var i = 0; i < increases.length; i++) {
      increases[i].focus();
    }
  }

  // click listener selectors
  var cartButtonMobile = document.querySelector('.cartButtonMobile');
  var cartDrawerClose = document.querySelector('.closeCart');
  var mobileMenuButton = document.querySelector('.mobileMenu');
  var menuClose = document.querySelector('.closeMobileMenu');

  //focuses close when when menu open
  mobileMenuButton.addEventListener("click", function (e) {
    setTimeout(function () {
      menuClose.focus();
    }, 300)
  })

  //focuses menu button on mobile close
  menuClose.addEventListener("click", function (e) {
    setTimeout(function () {
      mobileMenuButton.focus();
    }, 300)
  })

  //focuses close when when cart open
  cartButtonMobile.addEventListener("click", function (e) {
    setTimeout(function () {
      cartDrawerClose.focus();
    }, 300)
  })

  //focuses cart icon on cart close.
  cartDrawerClose.addEventListener("click", function (e) {
    setTimeout(function () {
      if (window.getComputedStyle(cartButtonMobile).display === "none") {
        cartButtonDesktop.focus();
      } else {
        cartButtonMobile.focus();
      }
    }, 300)
  })
})
//focusing search after close search
var focusThis;
document.addEventListener('theme:search:end', function() {
  var pageOverlay = document.getElementsByClassName('PageOverlay')[0]
  if (pageOverlay) {
    document.getElementsByClassName('PageOverlay')[0].classList.add('is-visible')
    pageOverlay.addEventListener('click', function (event) {
      document.getElementById('search_results').setAttribute('aria-hidden', 'true');
    })
  }
});

document.addEventListener('theme:loading:end', function () {
  setTimeout(function () {
    if (document.getElementById('searchClose')) {
      var closedSearch = document.getElementById('searchClose');
      closedSearch.addEventListener('keypress', function (event) {
        if (event.keyCode === 13) {
          this.closest('#search_results').setAttribute('aria-hidden', 'true');
          document.querySelector('.Search__Input').focus();
          setTimeout(function () {
            document.querySelector('.mobileSearch').focus();
          }, 300)
        }
      })
    }
    if (document.getElementById('searchCloseMobileMenu')) {
      var closedSearchMobile = document.getElementById('searchCloseMobileMenu');
      closedSearchMobile.addEventListener('keypress', function (event) {
        if (event.keyCode === 13) {
          setTimeout(function () {
            document.querySelector('.mobileSearch').focus();
          }, 300)
        }
      })
    }
  }, 300)
})

var openMenu = document.querySelector('.mobileMenu');
var closeMenu = document.querySelector('.closeMobileMenu');
openMenu.addEventListener('click', function () {
  openMenu.style.display = "none";
  closeMenu.style.display = "flex";
})

closeMenu.addEventListener('click', function () {
  closeMenu.style.display = "none";
  openMenu.style.display = "flex";
})

//functionality for nav arrows
var mainNavArrows = document.querySelectorAll('.mainNavLinkItem__ArrowContainer');
var arrowsArray = Array.from(mainNavArrows);

function openDropdown(menu, dropdown, item) {
  menu.classList.add('is-expanded');
  dropdown.setAttribute('aria-hidden', 'false');
  var tabName = item.getAttribute('data-tab');
  tabName = 'Close sub-menu ' + tabName;
  item.setAttribute('aria-label', tabName);
  item.setAttribute('aria-expanded', 'true');
}

function closeDropdown(menu, dropdown, item) {
  menu.classList.remove('is-expanded');
  item.classList.remove('is-expanded');
  dropdown.setAttribute('aria-hidden', 'true');
  var tabName = item.getAttribute('data-tab');
  tabName = 'Open sub-menu ' + tabName;
  item.setAttribute('aria-label', tabName);
  item.setAttribute('aria-expanded', 'false');
}

arrowsArray.forEach(function (item) {
  var menu = item.closest('.HorizontalList__Item');
  var dropDown = menu.lastElementChild;
  item.addEventListener("keypress", function (e) {
    if (e.key == "Enter") {
      //remove all expanded and up arrows when opening another menu
      arrowsArray.forEach(function (item1) {
        if (item != item1) {
          closeDropdown(item1.closest('.HorizontalList__Item'), item1.closest('.HorizontalList__Item').lastElementChild, item);
        }
      });

      //if expanded remove if not add
      if (menu.classList.contains('is-expanded')) {
        closeDropdown(menu, dropDown, item);
      } else {
        openDropdown(menu, dropDown, item);
      }
    }
  })
  // check for mouse over for hover functionality
  item.closest('.HorizontalList__Item').addEventListener("mouseover", function (e) {
    openDropdown(menu, dropDown, item);
  });

  item.closest('.HorizontalList__Item').addEventListener("mouseout", function (e) {
    closeDropdown(menu, dropDown, item);
  });

  document.addEventListener('focusin', function () {
    if (!dropDown.contains(document.activeElement)) {
      closeDropdown(menu, dropDown, item);
    }
  }, true);
})

/* Loading Vimeo Videos */
window.addEventListener('DOMContentLoaded', function () {
  var vimeoBtns = document.querySelectorAll('.vimeo-load');
  var vimeoVideos = document.querySelectorAll('.vimeo-video');

  function addVimeoAPI(containerID) {
    var vimeoScript = document.getElementById(window.theme.vimeo.id);
    if (!vimeoScript) {
      var el = document.createElement('script');
      el.setAttribute('src', window.theme.vimeo.js);
      el.setAttribute('id', window.theme.vimeo.id);
      document.head.appendChild(el);
      var timeout = setInterval(function () {
        if (typeof Vimeo != 'undefined') {
          clearInterval(timeout);
          createVimeoPlayer(containerID);
        }
      }, 100);
    } else {
      createVimeoPlayer(containerID);
    }
  }

  function createVimeoPlayer(containerID) {
    var player = new Vimeo.Player(containerID);
    return player;
  }

  function initVimeo(el) {
    var containerID = el.getAttribute('data-vimeo-container');
    if (!containerID) {
      containerID = el.id;
    }
    var vimeoContainer = document.getElementById(containerID);
    if (vimeoContainer) {
      addVimeoAPI(containerID)
    }
  }

  vimeoBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      initVimeo(this);
    });
  });

  var videoHandler = function (entries, observer) {
    entries.forEach(function (entry) {
      var el = entry.target;
      if (!entry.isIntersecting || window.getComputedStyle(el).display === "none") return;
      videoObserver.unobserve(el);
      initVimeo(el);
    });
  }

  var videoObserver = new IntersectionObserver(videoHandler, { rootMargin: '200px 0px 200px 0px' });
  vimeoVideos.forEach(function (video) {
    videoObserver.observe(video);
  });
});

/* Swiper Sliders */
window.addEventListener('DOMContentLoaded', function () {
  var swipers = document.querySelectorAll('.swiper-slider');

  function addSwiper(el) {
    var swiperScript = document.getElementById(window.theme.swiper.id);
    if (!swiperScript) {
      var script = document.createElement('script');
      script.setAttribute('src', window.theme.swiper.js);
      script.setAttribute('id', window.theme.swiper.id);
      document.head.appendChild(script);
      var styles = document.createElement('link');
      styles.setAttribute('href', window.theme.swiper.css);
      styles.setAttribute('rel', 'stylesheet');
      styles.setAttribute('id', 'swiper-css');
      document.head.appendChild(styles);
    }
    var timeout = setInterval(function () {
      if (typeof Swiper != 'undefined') {
        clearInterval(timeout);
        initSwiper(el);
      }
    }, 100);
  }

  function initSwiper(el) {
    var sectionID = el.dataset.sectionId;
    var options = window.swiperOptions[sectionID];
    options.preloadImages = true;
    options.updateOnImagesReady = true;
    options.on = options.on || {};
    options.on.imagesReady = function (swiper) { setTimeout(function () { swiper.update(); }, 1000) };
    var selector = '#' + el.id;
    var sliderType = el.dataset.sliderType || 'always';
    var swiper = null;
    if (sliderType == 'mobile') {
      if (window.matchMedia("(max-width: 767px)").matches) {
        swiper = new Swiper(selector, options);
      }
      window.addEventListener('resize', function () {
        if (window.matchMedia("(min-width: 768px)").matches && swiper !== null) {
          swiper.destroy();
          swiper = null;
        } else if (window.matchMedia("(max-width: 767px)").matches && swiper == null) {
          swiper = new Swiper(selector, options);
        }
      });
    } else {
      swiper = new Swiper(selector, options);
    }
    return swiper;
  }

  var swiperHandler = function (entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      swiperObserver.unobserve(el);
      addSwiper(el);
    });
  }
  var swiperObserver = new IntersectionObserver(swiperHandler);
  swipers.forEach(function (el) {
    swiperObserver.observe(el);
  });

  if (Shopify.designMode) {
    window.addEventListener('shopify:section:select', function (e) {
      swipers.forEach(function (el) {
        addSwiper(el);
      });
    });
  }

});


/****** Back to Top Button *******/
window.addEventListener('DOMContentLoaded', function () {
  var goTopBtn = document.getElementById('back-to-top-button');
  function trackScroll() {
    var scrolled = window.pageYOffset;
    var coords = document.documentElement.clientHeight + window.theme.backToTopButton.displayLocation;
    if (scrolled > coords) {
      goTopBtn.style.display = "flex";
    }
    if (scrolled < coords) {
      goTopBtn.style.display = "none";
    }
  }

  function backToTop() {
    if (window.pageYOffset > 0) {
      window.scroll({ top: 0, behavior: 'smooth' });
    }
  }

  window.addEventListener('scroll', trackScroll);
  goTopBtn.addEventListener('click', backToTop);
});

document.addEventListener('theme:search:end', function () {
  var searchRedirectsEl = document.querySelector('.search-redirects-map');
  if (searchRedirectsEl) {
    var redirects = JSON.parse(searchRedirectsEl.innerHTML);
    var currentSearchTerm = searchRedirectsEl.dataset.searchTerm;
    hwSearchRedirects(redirects, currentSearchTerm);
  }
});


window.addEventListener('DOMContentLoaded', function () {
  var videos = document.querySelectorAll('.html5-video');
  var clickVideos = document.querySelectorAll('.html5-video-button');

  var videoAddHandler = function (entries, observer) {
    entries.forEach((entry) => {
      var el = entry.target;
      if (!entry.isIntersecting) return;
      addVideo(el);
      videoAddObserver.unobserve(el);
    });
  }

  var videoPlayPauseHandler = function (entries, observer) {
    entries.forEach((entry) => {
      var el = entry.target;
      if (entry.isIntersecting) {
        el.play();
      } else {
        var pauseVideo = true;
        var fixedAncestor = el.closest('.fixed');
        if (fixedAncestor) {
          pauseVideo = false;
          if (fixedAncestor.classList.contains('bottom')) {
            pauseVideo = true;
          }
        }
        if (pauseVideo) {
          el.pause();
        }
      }
    });
  }

  var videoAddObserver = new IntersectionObserver(videoAddHandler, { rootMargin: '400px 0px 400px 0px' });
  var videoPlayPauseObserver = new IntersectionObserver(videoPlayPauseHandler, { threshold: 0.5 })
  videos.forEach((el) => {
    videoAddObserver.observe(el);
  });
  clickVideos.forEach((el) => {
    el.addEventListener('click',() => {
      var videoEl = document.getElementById(el.dataset.id);
      if(videoEl){
        videoEl.classList.remove('hide');
        addVideo(videoEl,true);
        el.remove();
      }
    });
  });

  function addVideo(el,playVideo) {
    var sources = el.querySelectorAll('source');
    sources.forEach((source) => {
      source.src = source.dataset.src;
    });
    if(el.closest('.html5-video-wrapper')){
      el.addEventListener('loadedmetadata', function () {
        var ar = this.videoWidth / this.videoHeight;
        el.closest('.html5-video-wrapper').style.setProperty('--aspect-ratio', ar);
      });
    }
    el.load();
    if (el.autoplay) {
      videoPlayPauseObserver.observe(el);
    }
    if(playVideo){
      el.play();
    }
  }
});
